import httpClient from "../httpClient";
import { API_USER_DELETE } from "../config";

const deleteUser = {
  delete: (id) => httpClient.delete(API_USER_DELETE+'/'+id),
};

export default deleteUser;